// extracted by mini-css-extract-plugin
module.exports = {"box":"GridEle_box__2faYn","Moderate":"GridEle_Moderate__2TMy7","Low":"GridEle_Low__2rlOK","High":"GridEle_High__1ZTGR"};